module.exports = __webpack_public_path__ + "img/TW.35558b67.svg";